import React from 'react'
import './Sec5AcademicStrength.css'

const centers = [
    {
      "number": "680+",
      "title": "Total Number of Mid-market GCC Units (FY2025E)"
    },
    {
      "number": "1.3X",
      "title": "Higher Mid-market GCCs in Transformation Hub as compared to non-Mid-market GCCs",
      "below_title": ""
    },
    {
      "number": "~47%",
      "title": "of the global Product Management talent in Mid-market GCCs is anchored in India ",
      "below_title": ""
    }
  ];

function Sec5AcademicStrength() {
    return (
        <div className="sec5AcademicStrength-container container">
          <div className="sec5AcademicStrength-content">
            <h1 className="Title">Mid-market GCCs are shaping a new global blueprint</h1>
    
            <div className="sec5AcademicStrength-text">
              <div className="sec5AcademicStrength-paragraph">
                    <p className='text'>If large GCCs are the established institutions, Mid-market GCCs are fast becoming the start-up engine of India’s global delivery landscape.
                      Smaller in size but not in ambition, these centers operate with the agility, focus, and velocity that mirrors the very best of India’s start-up culture. And much like the early-stage companies that have redefined India’s innovation narrative, Mid-market GCCs are now doing the same for global capability building. </p>
                      <p className='text'> They’re leaner, flatter, and structurally more open, offering talent direct access to leadership, hands-on involvement in product strategy, and in many cases, a seat at the global table. It’s not uncommon for leaders in these centers to report directly to CEOs and Boards, something rarely seen in larger, layered setups.
                    </p>
                      
                </div>
                <div className="sec5AcademicStrength-centers-wrapper">
                    {centers.map((item, index) => (
                    <div className="sec5AcademicStrength-Centers" key={index}>
                        <h3 className="sec5AcademicStrength-centers-num">{item.number}</h3>
                        <p className="sec5AcademicStrength-centers-details sec5AcademicStrength-centers-text"><b>{item.top_title}</b></p>
                        <p className="sec5AcademicStrength-centers-details sec5AcademicStrength-centers-text">{item.title}</p>
                        <p className="sec5AcademicStrength-centers-details sec5AcademicStrength-centers-text"><b>{item.below_title}</b></p>
                    </div>
                    ))}
                </div>
            </div>
          </div>
        </div>
      );
}

export default Sec5AcademicStrength
